import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + '/v1';

class MockService {
  getMocks() {
    return axios.get(API_URL + '/mocks', { headers: authHeader() });
  }

  uploadFile(formData) {
    console.log('UPLOADING FILE: ', formData);
    return axios.post(API_URL+ '/mocks', formData, { headers: {'Content-Type': 'multipart/form-data'} });
  }

  uploadFileforsearchtermfolder(formData) {
    console.log('UPLOADING FILE: ', formData);
    return axios.post(API_URL+ '/uploadFile', formData, { headers: {'Content-Type': 'multipart/form-data'} });
  }
}

export default new MockService();
